// Room Crawler route — gated behind VITE_FF_ROOM_CRAWLER.
// -----------------------------------------------------------------
// Per docs/architecture/dispatches/m7-1-producer-pipeline.md § 4.2.
//
// Replaces the Flask /room-crawler page (admin/routes/room_crawler.py).
// When the flag is off (default in both staging and prod), the route
// mounts and immediately <Navigate replace />s to /hello, matching
// the M3.4 placeholder pattern used by dashboards/tour-planner/prompts.
//
// Flag flips at M7.1-L1 staging + M7.1-L2 prod per dispatch § 5.
// The Flask page itself remains accessible (localhost-only) until
// M7-mid retirement per dispatch § 0.5.

import { Navigate, createFileRoute } from '@tanstack/react-router';

import { RoomCrawlerPage } from '@/components/room-crawler/RoomCrawlerPage';
import { isFeatureEnabled } from '@/lib/featureFlags';

const RoomCrawlerRoute = () => {
  if (!isFeatureEnabled('ROOM_CRAWLER')) {
    return <Navigate to='/hello' replace />;
  }
  return <RoomCrawlerPage />;
};

export const Route = createFileRoute('/_authenticated/room-crawler')({
  component: RoomCrawlerRoute,
});
